import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable()
export class ApiService {
  private baseURL: string = environment.rootAPI + '/';
  private redirectURL: string = environment.redirect;
  private sessionKey = '';
  private defaultRootPath = 'embed/';

  constructor(private http: HttpClient) {}

  createAuthorizationHeader(
    headers: HttpHeaders,
    rootPATH: string = 'embed',
    extraHEADERS: any = {}
  ) {
    if (Object.keys(extraHEADERS).length > 0) {
      return headers.set('Authorization', extraHEADERS['Authorization']);
    }
    return headers;
  }

  // Passing in rootPATH (for using auth microservice)
  public get(
    url: string,
    data: any = {},
    rootPATH: string = this.defaultRootPath,
    extraHEADERS: any = {},
    responseType: string = ''
  ) {
    const headers = new HttpHeaders();
    const options = {
      headers: this.createAuthorizationHeader(headers, rootPATH, extraHEADERS),
      params: data
    };
    if (responseType) {
      options['responseType'] = responseType;
    }
    let path = '';
    if (rootPATH == null) {
      path = url;
    } else {
      path = this.baseURL + rootPATH + url;
    }
    if (rootPATH == null) {
      return this.http.get(url);
    } else {
      return this.http.get(path, options);
    }
  }

  public post(
    url: string,
    data: any = {},
    rootPATH: string = this.defaultRootPath,
    extraHEADERS: any = {}
  ) {
    const path = this.baseURL + rootPATH + url;
    const headers = new HttpHeaders();
    return this.http.post(path, data, {
      headers: this.createAuthorizationHeader(headers, rootPATH, extraHEADERS)
    });
  }

  public del(url: string, rootPATH: string = this.defaultRootPath) {
    const headers = new HttpHeaders();
    const path = this.baseURL + rootPATH + url;
    return this.http.delete(path, {
      headers: this.createAuthorizationHeader(headers, rootPATH)
    });
  }

  public put(
    url: string,
    data: any = {},
    rootPATH: string = this.defaultRootPath
  ) {
    const headers = new HttpHeaders();
    const path = this.baseURL + rootPATH + url;
    return this.http.put(path, data, {
      headers: this.createAuthorizationHeader(headers, rootPATH)
    });
  }
}
